import React from "react";
import { Link } from "react-router-dom";

const ViewDealerModal = ({
  show,
  dealer,
  onClose,
  onToggleStatus,
  isUpdatingStatus,
  onDeleteDealer,
}) => {
  if (!show || !dealer) {
    return null;
  }

  const formatCoins = (value) => {
    return Number(value || 0).toLocaleString("en-IN", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  };

  const formatDate = (dateString) => {
    if (!dateString) return "N/A";
    return new Date(dateString).toLocaleString("en-IN");
  };

  const isActive = String(dealer.status || "ACTIVE").toUpperCase() === "ACTIVE";

  return (
    <>
      <div
        className="modal-backdrop fade show"
        style={{ zIndex: 1050 }}
        onClick={onClose}
      />

      <div
        className="modal fade show d-block"
        tabIndex="-1"
        role="dialog"
        aria-modal="true"
        style={{ zIndex: 1055, overflow: "hidden" }}
        onMouseDown={(event) => {
          if (event.target === event.currentTarget) {
            onClose();
          }
        }}
      >
        <div
          className="modal-dialog modal-dialog-centered"
          style={{ maxWidth: "480px", margin: "10px auto" }}
        >
          <div
            className="modal-content border border-[rgba(148,163,184,0.2)] bg-[#121827] shadow-2xl rounded-2xl overflow-hidden text-[#F8FAFC]"
            style={{ maxHeight: "calc(100vh - 20px)" }}
          >
            {/* HEADER */}
            <div className="modal-header bg-[#0D111C] border-b border-[rgba(148,163,184,0.14)] py-3 px-4 d-flex align-items-center justify-content-between">
              <div className="d-flex align-items-center gap-2.5">
                <div className="flex h-9 w-9 items-center justify-center rounded-xl bg-[#D4AF37]/10 text-[#D4AF37] border border-[#D4AF37]/30 text-lg font-bold">
                  👑
                </div>
                <div>
                  <h5 className="modal-title fw-bold text-[#F8FAFC] fs-6 mb-0">
                    Dealer Details
                  </h5>
                  <div className="text-[10px] text-[#94A3B8]">
                    @{dealer.username || "N/A"}
                  </div>
                </div>
              </div>

              <button
                type="button"
                className="btn-close btn-close-white"
                aria-label="Close"
                onClick={onClose}
              />
            </div>

            {/* BODY */}
            <div className="modal-body p-4 space-y-4">
              {/* DEALER NAME & STATUS BANNER */}
              <div className="p-3.5 rounded-xl bg-[#0D111C] border border-[rgba(148,163,184,0.14)] d-flex align-items-center justify-content-between">
                <div>
                  <div className="text-[10px] font-bold uppercase tracking-wider text-[#64748B] mb-0.5">
                    Dealer Name
                  </div>
                  <div className="fw-bold fs-5 text-[#F8FAFC]">
                    {dealer.full_name || "Unnamed Dealer"}
                  </div>
                </div>

                <span
                  className={`status-pill ${isActive ? "active" : "blocked"}`}
                >
                  {isActive ? "ACTIVE" : "BLOCKED"}
                </span>
              </div>

              {/* WALLET BALANCE HIGHLIGHT */}
              <div className="p-3.5 rounded-xl bg-[#0D111C] border border-[rgba(148,163,184,0.14)] d-flex align-items-center justify-content-between">
                <div>
                  <div className="text-[10px] font-bold uppercase tracking-wider text-[#64748B] mb-0.5">
                    Available Dealer Wallet
                  </div>
                  <div className="fw-extrabold fs-4 text-[#D4AF37]">
                    🪙 {formatCoins(dealer.wallet)}
                  </div>
                </div>
                <div className="h-10 w-10 rounded-xl bg-[#D4AF37]/10 text-[#D4AF37] border border-[#D4AF37]/30 d-flex align-items-center justify-content-center fs-5">
                  <i className="bi bi-wallet2" />
                </div>
              </div>

              {/* DETAILS GRID */}
              <div className="row g-3">
                <div className="col-6">
                  <div className="p-3 rounded-xl bg-[#0D111C] border border-[rgba(148,163,184,0.14)] h-100">
                    <div className="text-[10px] font-bold uppercase tracking-wider text-[#64748B] mb-1">
                      Mobile Number
                    </div>
                    <div className="fw-bold text-[#F8FAFC] small">
                      <i className="bi bi-telephone me-1.5 text-[#94A3B8]" />
                      {dealer.mobile || "N/A"}
                    </div>
                  </div>
                </div>

                <div className="col-6">
                  <div className="p-3 rounded-xl bg-[#0D111C] border border-[rgba(148,163,184,0.14)] h-100">
                    <div className="text-[10px] font-bold uppercase tracking-wider text-[#64748B] mb-1">
                      Total Shops
                    </div>
                    <div className="fw-bold text-[#D4AF37] small">
                      <i className="bi bi-shop me-1.5" />
                      {Number(dealer.total_shops || 0)} Shops
                    </div>
                  </div>
                </div>

                <div className="col-12">
                  <div className="p-3 rounded-xl bg-[#0D111C] border border-[rgba(148,163,184,0.14)]">
                    <div className="text-[10px] font-bold uppercase tracking-wider text-[#64748B] mb-1">
                      Registered Date
                    </div>
                    <div className="fw-medium text-[#CBD5E1] small">
                      <i className="bi bi-calendar3 me-1.5 text-[#94A3B8]" />
                      {formatDate(dealer.created_at)}
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* ACTIONS */}
            <div className="modal-footer bg-[#0D111C] border-t border-[rgba(148,163,184,0.14)] py-3 px-4 d-flex justify-content-end gap-2">
              {onDeleteDealer && (
                <button
                  type="button"
                  className="btn btn-danger text-xs px-3.5 py-2 fw-bold me-auto"
                  onClick={() => onDeleteDealer(dealer)}
                >
                  <i className="bi bi-trash me-1.5" />
                  Delete Dealer
                </button>
              )}

              <button
                type="button"
                className="btn btn-secondary text-xs px-3 py-2"
                onClick={onClose}
              >
                Close
              </button>

              <Link
                to="/transfer-dealer"
                state={{ dealer }}
                className="btn btn-primary text-xs px-3.5 py-2 fw-bold"
                onClick={onClose}
              >
                <i className="bi bi-send me-1.5" />
                Transfer Coins
              </Link>

              <button
                type="button"
                className={`btn text-xs px-3.5 py-2 fw-bold ${
                  isActive ? "btn-outline-danger" : "btn-outline-success"
                }`}
                disabled={isUpdatingStatus}
                onClick={async () => {
                  const success = await onToggleStatus(dealer);
                  if (success) {
                    onClose();
                  }
                }}
              >
                {isUpdatingStatus ? (
                  <>
                    <span className="spinner-border spinner-border-sm me-1.5" />
                    Updating...
                  </>
                ) : (
                  <>
                    <i
                      className={`bi me-1.5 ${
                        isActive ? "bi-lock-fill" : "bi-unlock-fill"
                      }`}
                    />
                    {isActive ? "Block Dealer" : "Unblock Dealer"}
                  </>
                )}
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ViewDealerModal;
